import list from './list';
import getDetail from './detail';
import viewMatch from './viewMatch';
import match from './match';
import send from './send';
import saveMatch from './saveMatch';
import finishMatch from './finishMatch';
import invalid from './invalid';
import invoiceList from './invoiceList';

export default {
    list,
    getDetail,
    viewMatch,
    match,
    send,
    saveMatch,
    invalid,
    finishMatch,
    invoiceList
};



// WEBPACK FOOTER //
// ./src/api/inputSettlement/index.ts